<router-outlet></router-outlet>
<et-footer class="print:hidden"></et-footer>
<!-- Alerts placeholder -->
<et-notifications-list></et-notifications-list>
